import PropTypes from 'prop-types';
import { GlobalContext } from '../utils/GlobalContext';
import { useEffect, useState, useContext } from 'react';
import { CONSTANT } from '../utils/constants';
import axios from 'axios';
import SpinnerComponent  from '../utils/SpinnerComponent';
import { formatNumber, isDiamondPriceHidden } from '../utils/helpers';
import '../../css/GenericBuilder/BaskPreview.css';

const BasketPreview = ({ handlePagesChanges,handleBackCondition }) => {
    const { basket, addToBasket, removeFromBasket, golbalClientDetails, client_code, flags } = useContext(GlobalContext);
    const [stoneDetails, setStoneDetails] = useState({});
    const [basketCount, setBasketCount] = useState(0);
    const [loadingContent, setLoadingContent] = useState(false);
    const { category } = useContext(GlobalContext);

    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', zipcode: '' });
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const [formError, setFormError] = useState('');

    const fetchItemName = async (item_ids) => {
        const baseUrl = `${CONSTANT.BASE_URL}api/Builder/fetch-item-details`;
        try {
            const response = await axios.post(baseUrl, { item_id: item_ids });
            let final_details = {};
            final_details[item_ids] = response.data;
            return final_details;
        } catch (error) {
            console.error('Error fetching items:', error);
            return {};
        }
    };

    useEffect(() => {
        setLoadingContent(true);
        const loadStoneDetails = async () => {
            if (basket && Object.keys(basket).length > 0) {
                const stoneIds = Object.values(basket).flatMap((item) => item.stones);
                const uniqueStoneIds = [...new Set(stoneIds)];

                try {
                    const details = await Promise.all(uniqueStoneIds.map(fetchItemName));
                    const combinedDetails = details.reduce((acc, curr) => ({ ...acc, ...curr }), {});
                    await setStoneDetails(combinedDetails);
                    setLoadingContent(false);
                } catch (error) {
                    setLoadingContent(false);
                    console.error("Error fetching stone details:", error);
                }
            }
        };
        setBasketCount(Object.keys(basket).length);
        loadStoneDetails();
    }, [basket]);

    const handleGoBack = () => {
        handlePagesChanges('Main','Complete');
    };

    const handleRemoveItem = (productCode) => {
        removeFromBasket(productCode);
    };

    const handleFormChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleContactStore = async (e) => {
        e.preventDefault();
        setFormSubmitting(true);
        setFormError('');

        const retailerEmail = golbalClientDetails?.client_id?.[0]?.account_email ?? '';

        const payload = new FormData();
        payload.append('name',          formData.name);
        payload.append('email',         formData.email);
        payload.append('phone',         formData.phone);
        payload.append('zipcode',       formData.zipcode);
        payload.append('account',       client_code);
        payload.append('contact_email', retailerEmail);
        payload.append('product',       JSON.stringify(basket));

        try {
            await axios.post(`${CONSTANT.BASE_URL}api/Builder/contact-store`, payload);
            setFormSuccess(true);
            setFormData({ name: '', email: '', phone: '', zipcode: '' });
        } catch (error) {
            console.error('Contact store error:', error);
            setFormError('Something went wrong. Please try again.');
        } finally {
            setFormSubmitting(false);
        }
    };

    // HIDE_DIAMOND_PRICE: the basket item keeps the diamond price for the store; only the shown totals drop it
    const hideDiamondPrice = isDiamondPriceHidden(flags);
    const shownItemPrice = (item) => (item.price || 0) - (hideDiamondPrice ? (parseFloat(item['Diamond Price']) || 0) : 0);
    const totalPrice = Object.values(basket).reduce((total, item) => total + shownItemPrice(item), 0);
    const excludeKeys = ["itemDetails", "shahApiProduct", ...(hideDiamondPrice ? ["Diamond Price"] : [])];
    useEffect(() => {
        console.log('Item Details Prices: ',basket);
    },[]);

    return (
        <>
            {loadingContent ? (
                <SpinnerComponent />
            ):(
                <div className='AddBasket'>
                    <div className="row grid-row">
                        <div className="col-12">
                            <button className="btn btn-primary" onClick={handleGoBack} style={{ fontSize: 'small' }}>
                                <i className="fa fa-arrow-left"></i>&nbsp;Go Back
                            </button>
                        </div>
                        <div className="col-12">
                            <div className="row grid-row">
                                <div className="col-12 col-sm-10">
                                    <h5>MY CART (ITEMS {basketCount})</h5>
                                    {Object.entries(basket).map(([productCode, itemDetails]) => (
                                        <div key={productCode} className="col-12 items" style={{ display: 'block' }}>
                                            <div className="card item-card-basket" style={{ borderRadius: '20px', boxShadow: '5px 10px #dddbdb', marginTop: '15px' }}>
                                                <div className="card-body" style={{ padding: '10px' }}>
                                                    <div className="row" style={{ fontSize: 'larger' }}>
                                                        <div className="col-lg-12" style={{ textAlign: 'end', position: 'relative' }}>
                                                            <button className="btn btn-default" onClick={() => handleRemoveItem(productCode)} >Remove</button>
                                                        </div>
                                                        { category === 'Ring Builder' ? (
                                                            <div className="col-lg-3">
                                                                <img src={itemDetails?.itemDetails?.thumb_image} style={{ width: '100%', height: 'auto' }} alt="Item" />
                                                            </div>
                                                        ):(
                                                        <div className="col-lg-3">
                                                            <img src={CONSTANT.BASE_URL+itemDetails?.itemDetails?.thumb_image} style={{ width: '100%', height: 'auto' }} alt="Item" />
                                                        </div>

                                                        )}
                                                        {category === 'Bangle Builder' || category === 'pickleball' || category === 'Ring Builder' ? (
                                                            <div className="col-lg-9">
                                                                <h5>{itemDetails?.itemDetails?.product_name}</h5>
                                                                <div className="row grid-row main-table-grid" style={{fontSize:`smaller`}}>
                                                                    {Object.entries(itemDetails).map(([key, value]) =>
                                                                        !excludeKeys.includes(key) ? (
                                                                            <>
                                                                                {key != 'price' && key != 'Head + Shank Price' ? (
                                                                                    <>
                                                                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid"><strong>{key}</strong></div>
                                                                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-right">{value}</div>
                                                                                    </>
                                                                                ):key != 'price' && key == 'Head + Shank Price' && (
                                                                                    <>
                                                                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid"><strong>{key}</strong></div>
                                                                                        <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-right" >{formatNumber(value)}</div>
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        ) : null
                                                                    )}
                                                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12'></div>
                                                                    {itemDetails?.price > 0 && (
                                                                        <>
                                                                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 table-grid table-grid-right"><strong>Center Stone is not included	</strong></div>
                                                                            <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-bottom"><strong>Total Price:</strong></div>
                                                                            <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-bottom">{formatNumber(shownItemPrice(itemDetails))}</div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ):(
                                                            <div className="col-lg-9">
                                                                <h5>{itemDetails.itemDetails.product_name}</h5>
                                                                <div className="row grid-row main-table-grid">
                                                                    <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid">Metal Type</div>
                                                                    <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-right">{itemDetails.metal_type}</div>
                                                                    <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid">Metal Color</div>
                                                                    <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-right">{itemDetails.metal_color}</div>
                                                                    {itemDetails.stones.map((stone, index) => (
                                                                        <>
                                                                            <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid">Stone {index + 1}</div>
                                                                            <div className="col-6 col-sm-3 col-md-3 col-lg-3 table-grid table-grid-right">
                                                                                {stoneDetails[stone]?.ringbuilder?.product_name || 'Loading...'}
                                                                            </div>
                                                                        </>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-12 col-sm-2 summary summary-basket">
                                    <h5>SUMMARY</h5>
                                    <div className="card" style={{ borderRadius: '20px', boxShadow: '5px 10px #dddbdb' }}>
                                        <div className="card-body">
                                            <div className="row" style={{ fontSize: 'larger' }}>
                                                <div className="col-lg-7 txt-align">Total</div>
                                                <div className="col-lg-5 txt-align">
                                                    <span className="prices">${formatNumber(totalPrice.toFixed(2))}</span>
                                                </div>
                                                <div className="col-lg-12">
                                                    <hr style={{ border: '1px solid #dddbdb' }} />
                                                </div>
                                                <div className="col-lg-12" style={{ textAlign: 'center' }}>
                                                    <button
                                                        onClick={() => { setShowModal(true); setFormSuccess(false); setFormError(''); }}
                                                        className="btn btn-primary"
                                                        style={{ fontSize: '12px', margin: '5px' }}
                                                    >
                                                        <i className="fa fa-phone"></i>&nbsp;Contact Store
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Store Modal */}
                    {showModal && (
                        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1050 }}>
                            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '480px', margin: '1.75rem auto' }}>
                                <div className="modal-content" style={{ borderRadius: '12px' }}>
                                    <div className="modal-header">
                                        <h5 className="modal-title">Contact Store</h5>
                                        <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                    </div>
                                    <div className="modal-body">
                                        {formSuccess ? (
                                            <div className="alert alert-success">
                                                Your request has been sent to the store. We will contact you shortly!
                                            </div>
                                        ) : (
                                            <form onSubmit={handleContactStore}>
                                                {formError && <div className="alert alert-danger">{formError}</div>}
                                                <div className="mb-3">
                                                    <label className="form-label">Name <span style={{ color: 'red' }}>*</span></label>
                                                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleFormChange} required />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                                    <input type="email" className="form-control" name="email" value={formData.email} onChange={handleFormChange} required />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Phone</label>
                                                    <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleFormChange} />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Zip Code</label>
                                                    <input type="text" className="form-control" name="zipcode" value={formData.zipcode} onChange={handleFormChange} />
                                                </div>
                                                <div className="d-flex justify-content-end gap-2">
                                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                                                    <button type="submit" className="btn btn-primary" disabled={formSubmitting}>
                                                        {formSubmitting ? 'Sending...' : 'Send to Store'}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

BasketPreview.propTypes = {
    clientDetails: PropTypes.object.isRequired,
    clientLayerDetails: PropTypes.object.isRequired,
    handlePagesChanges: PropTypes.func.isRequired,
};

export default BasketPreview;
